<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <a class="navbar-brand" href="#">Torreón Market</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Productos
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" [routerLink]="['/administrador']">Inventario</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" [routerLink]="['/nuevo']">Nuevo Producto</a>
                </div>
            </li>
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Blog
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" [routerLink]="['/listaPost']">Artículos</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" [routerLink]="['/newPost']">Crear Artículo</a>
                </div>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/categ']">Categorías</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/pedidos']">Pedidos</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/clientes']">Clientes</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/suscriptores']">Suscriptores</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/mensajes']">Mensajes</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" (click)="onLogout()">Salir</a>
            </li>
        </ul>
    </div>
</nav>